export const actions = {
    START_FETCHING_STAT: "START_FETCHING_STAT",
    FETCH_STAT_SUCCESSFUL: "FETCH_STAT_SUCCESSFUL",
    FETCH_STAT_FAILED: "FETCH_STAT_FAILED",
    STORE_STAT_DATA: "STORE_STAT_DATA",
    CLEAR_STATS: "CLEAR_STATS",
};

export const initialState = {
    singleFetching: [],
};

export default (state = initialState, { type, response, iri }) => {
    switch (type) {
        case actions.START_FETCHING_STAT: {
            const newFetching = Array.from(state.singleFetching);
            newFetching.push(iri);
            return {
                ...state,
                singleFetching: newFetching,
            };
        }
        case actions.FETCH_STAT_SUCCESSFUL: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.FETCH_STAT_FAILED: {
            return {
                ...state,
                singleFetching: state.singleFetching.filter((item) => item !== iri),
            };
        }
        case actions.STORE_STAT_DATA: {
            return Object.assign({}, state, {
                [iri]: response,
            });
        }
        case actions.CLEAR_STATS: {
            return {
                ...initialState,
            };
        }
        default:
            return state;
    }
};
